  const wishlist_api = 'https://shopify-wishlist.matat.io';
      // ${
//             product.has_only_default_variant == "false" || product.has_only_default_variant == 0 || product.has_only_default_variant == false
//               ? `<a href="${product.url}" class="btn-add-cart demo">${wishlist.choose_option}</a>`
//               : `<add-to-cart href="${product.url}" class="btn-add-cart demo" data-variant-id="${product.variantId}" data-id="${product.id}"  role="button" tabindex="0">${wishlist.add_to_cart}</add-to-cart><form method="post" action="/cart/add" id="product-form-template--20440754225444__product-grid8653905461540" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form"><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="id" value="${product.variantId}" class="product-variant-id"></form>`
//           }
  class WishlistDrawer extends HTMLElement {
    constructor() {
      super();
      if (typeof customer_id !== 'undefined') {
            this.syncWithServer();
              this.syncWishlistToServer();
            this.renderContentFromSessionStorage();
      }
      this.createUniqueUserID();
      if (localStorage.getItem('visitCount')) {
        let visitCount = parseInt(localStorage.getItem('visitCount'));
        visitCount++;
        if (visitCount % 5 === 0) {
          this.syncWishlistToServer();
          visitCount = 0;
        }
        localStorage.setItem('visitCount', visitCount.toString());
      } else {
        localStorage.setItem('visitCount', '1');
      }
      this.renderContentFromSessionStorage();
      this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
      this.querySelector('#WishlistDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.setHeaderCartIconAccessibility();
    }


    syncWithServer(){
      var userId = localStorage.getItem('userId');
      if(userId!=customer_id){

      const endpoint = `${wishlist_api}/api/wishlist/sync`;
      const dynamicPayload = {
        user_id: userId,
        customer_id: customer_id
      };
      const dynamicPayloadJSON = JSON.stringify(dynamicPayload);
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: dynamicPayloadJSON,
      };
    
      fetch(endpoint, requestOptions)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json();
        })
        .then(data => {
          localStorage.setItem('userId', customer_id);
        })
        .catch(error => {
        });
      }
    }

    createUniqueUserID(){
      const existingUserId = localStorage.getItem('userId');

      if (!existingUserId) {
        // If it doesn't exist, generate a new user ID and save it to local storage
        const userId = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
        localStorage.setItem('userId', userId);
        return userId;
      }
    }

    syncWishlistToServer(){
      var userId = localStorage.getItem('userId');
        // Define the endpoint with the user_id parameter
        const endpoint = `${wishlist_api}/api/wishlist/${userId}`;
        // Define the options for the fetch request
        const requestOptions = {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        };
        // Send the GET request
        fetch(endpoint, requestOptions)
          .then(response => {
            if (!response.ok) {
              throw new Error('Network response was not ok');
            }
            return response.json(); // If you expect a JSON response
          })
          .then(data => {
            // Handle the response data here
            console.log("data wishlist",data)
            const localData = JSON.parse(localStorage.getItem('wishlist_items') || '[]');
            console.log("localData",localData)
            const mergedData = data.map(serverProduct => {
              const localProduct = localData.find(p => p.id === serverProduct.id);
              return { 
                ...serverProduct,
                tags: localProduct?.tags || serverProduct.tags || [],
                product_pergram: localProduct?.product_pergram || serverProduct.product_pergram || null,
                is_available: localProduct?.is_available || serverProduct.is_available || null
              };
            });
            localStorage.setItem('wishlist_items', JSON.stringify(mergedData));
            // sessionStorage.setItem('wishlist_items', JSON.stringify(data));
            this.renderContentFromSessionStorage();
          })
          .catch(error => {
            // Handle errors here
          });
      }

    setHeaderCartIconAccessibility() {
      const cartLink = document.querySelector('#wishlist-icon-bubble');
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink)
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    }

    open(triggeredBy) {
      if (triggeredBy) this.setActiveElement(triggeredBy);
      // const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
      // if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
      // here the animation doesn't seem to always get triggered. A timeout seem to help
      setTimeout(() => { this.classList.add('animate', 'active') });

      this.addEventListener('transitionend', () => {
        const containerToTrapFocusOn = document.getElementById('WishlistDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      }, { once: true });

      document.body.classList.add('overflow-hidden');
    }

    close() {
      this.classList.remove('active');
      removeTrapFocus(this.activeElement);
      document.body.classList.remove('overflow-hidden');
    }

    setSummaryAccessibility(cartDrawerNote) {
      cartDrawerNote.setAttribute('role', 'button');
      cartDrawerNote.setAttribute('aria-expanded', 'false');

      if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
        cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
      }

      cartDrawerNote.addEventListener('click', (event) => {
        event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
      });

      cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
    }

    renderWishlistItem(product) {
      console.log("product",product.is_available)
      let product_form_id = `quick-add-wishlist-${product.id}`;
      let tagsArray = product.tags ? `
        <div class="product-tag-review">
            <span>${product.tags}</span>
        </div>
      ` : '<div class="product-tag-review"></div>';
      let product_form_quick_view = ``;

      // if (product.tags) { // only run split if tags exist
      //   tagsArray = Array.isArray(product.tags) 
      //     ? product.tags 
      //     : product.tags.split(",");
      // }

      // let product_tags = tagsArray
      //   .map(tag => tag.trim()) // clean spaces
      //   .filter(tag => tag && tag.toLowerCase() !== "most loved") // skip "Most Loved"
      //   .map(tag => `<li class="tag">${tag}</li>`)
      //   .join("");
      if(product.is_available == "product_has") {
        product_form_quick_view = `
        <modal-opener data-modal="#QuickAdd-${product.id}">
                    <button
                      id="${product_form_id}-submit"
                      type="submit"
                      name="add"
                      class="quick-add__submit button button--full-width button--secondary{% if horizontal_quick_add %} card--horizontal__quick-add animate-arrow{% endif %}"
                      aria-haspopup="dialog"
                      aria-labelledby="${product_form_id}-submit title-${product.id}"
                      data-product-url="${product.url}"
                    >
                      הוספה לסל
                      <div class="loading-overlay__spinner loading__spinner hidden">
                        <svg
                          aria-hidden="true"
                          focusable="false"
                          class="spinner"
                          viewBox="0 0 66 66"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                        </svg>
                      </div>
                    </button>
                  </modal-opener>
                  <quick-add-modal id="QuickAdd-${product.id}" class="quick-add-modal">
                    <div
                      role="dialog"
                      aria-label="${product.title}"
                      aria-modal="true"
                      class="quick-add-modal__content global-settings-popup"
                      tabindex="-1"
                    >
                      <div class="quick-add-header">
                        <h5>מבט מהיר</h5>
                        <button
                          id="ModalClose-${product.id}"
                          type="button"
                          class="quick-add-modal__toggle"
                          aria-label="סגור"
                        >
                          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M17.8369 17.0392C18.0563 17.2586 18.0563 17.6152 17.8369 17.8346C17.7266 17.9449 17.5826 18 17.4386 18C17.2946 18 17.1506 17.9449 17.0403 17.8357L9.0007 9.79499L0.961076 17.8346C0.850821 17.9449 0.706814 18 0.562808 18C0.418801 18 0.274794 17.9449 0.164539 17.8357C-0.0548463 17.6164 -0.0548463 17.2597 0.164539 17.0403L8.20529 8.99958L0.164539 0.959951C-0.0548463 0.740566 -0.0548463 0.383924 0.164539 0.164539C0.383924 -0.0548463 0.740566 -0.0548463 0.959951 0.164539L9.0007 8.20417L17.0403 0.164539C17.2597 -0.0548463 17.6164 -0.0548463 17.8357 0.164539C18.0551 0.383924 18.0551 0.740566 17.8357 0.959951L9.79611 8.99958L17.8369 17.0392Z" fill="#001022"/>
                          </svg>
                        </button>
                      </div>
                      <div id="QuickAddInfo-${product.id}" class="quick-add-modal__content-info"></div>
                    </div>
                  </quick-add-modal>`;
      }else{
       product_form_quick_view =  `<div class="quick-add no-js-hidden OOS-matat">
                      <div class="sold-out-message">
                      <matat-stock data-id="${product.variantId}" data-product_id="${product.id}" data-action="matat_stock_notify" data-security="" data-title="${product.title}" data-price_varies="false" data-price="${product.price}" data-price_max="${product.price}" data-price_min="${product.price}" data-has_only_default_variant="true" data-src="${product.src}" data-url="${product.url}" data-user_id="" data-variant-id="${product.variantId}" data-email="" data-full_name="" data-variant-title="Default Title" class="matat-collection-stock">אשמח לעדכון כשהמלאי מתחדש</matat-stock>
                    </div>  
                </div>`;
      }
      
      return `
        <wishlist-item class="product-col">
          <div class="product-item card-wrapper">
            <div class="img-wrap">
              <wishlist-item-delete-button class="btn-remove-wishlist" data-id="${product.id}" role="button" tabindex="0">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" aria-hidden="true" focusable="false" class="icon icon-remove">
                <path d="M14 3h-3.53a3.07 3.07 0 00-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 005.53 3H2a.5.5 0 000 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 00.5-.5V4H14a.5.5 0 000-1zM6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02zm4.84 11.52h-7.5V4h7.5v9.5z" fill="currentColor"></path>
                <path d="M6.55 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5zM9.45 5.25a.5.5 0 00-.5.5v6a.5.5 0 001 0v-6a.5.5 0 00-.5-.5z" fill="currentColor"></path>
              </svg>
              </wishlist-item-delete-button>
              <a href="${product.url}" class="wishlist-product-wrap">
                <img width="150" height="200" src="${product.src}" class="attachment-woocommerce_thumbnail size-woocommerce_thumbnail" alt="Product Image" decoding="async" srcset="${product.src}" sizes="(max-width: 150px) 100vw, 150px">
              </a>
            </div>
            <div class="product_info">
              ${tagsArray}
              <h3 class="product-name">
                <a href="${product.url}">${product.title}</a>
              </h3>
              <div class="product_card_review">
                <div class="yotpo-widget-instance" 
                  data-yotpo-instance-id="1090310" 
                  data-yotpo-product-id="${product.id}">
                </div>
              </div>
              <p class="price_per_grm">${product.product_pergram}</p>
              <div class="product-price">
                <span class="woocommerce-Price-amount amount"><bdi>${product.price}</bdi></span>
              </div>
              ${product_form_quick_view}
            </div>
          </div>
        </wishlist-item>`;
    }

    renderContentFromSessionStorage() {
      const storedData = JSON.parse(localStorage.getItem('wishlist_items') || '[]');
      const wishlistItemsElement = document.querySelector('wishlist-items');
      const wishlistButtons = document.querySelectorAll('wishlist-button');
      console.log("storedData",storedData)
      if (storedData.length > 0) {
        const renderedItems = storedData.map(product => this.renderWishlistItem(product));
        wishlistItemsElement.innerHTML = renderedItems.join('\n');
        this.updateWishlistBubble();
      } else {
        wishlistItemsElement.innerHTML = '<p class="empty-wishlist">No items in wishlist</p>';
      }

      wishlistButtons.forEach(button => {
        button.classList.toggle('has_in_wishlist', this.checkIfProductExistInWishlist(button.dataset.id));
      });
    }

    checkIfProductExistInWishlist(productId){
      const storedData = localStorage.getItem('wishlist_items');
      if (storedData) {
        const productData = JSON.parse(storedData);
        // Check if any product has the provided productId
        const exists = productData.some(product => product.id === productId);
        return exists;
      } else {
        return false; // Assuming product doesn't exist if no data is available
      }
    }

    updateWishlistBubble() {
      let layout = "";
      const storedData = localStorage.getItem('wishlist_items');
      
      if (storedData && JSON.parse(storedData).length >= 1) {
        const productData = JSON.parse(storedData);
        layout = `<div class="wishlist-count-bubble">
          <span aria-hidden="true">${productData.length}</span>
          <span class="visually-hidden">${productData.length} Items</span>
        </div>`;
        this.setDrawerStatus(true);
      } else {
        layout = `<div class="wishlist-count-bubble empty-bubble">
          <span aria-hidden="true">0</span>
          <span class="visually-hidden">0 Items</span>
        </div>`;
        this.setDrawerStatus(false);
      }
    
      const containers = document.querySelectorAll('.wishlist-bubble-container');
      containers.forEach(container => {
        container.innerHTML = layout;
      });
    }

    setActiveElement(element) {
      this.activeElement = element;
    }

    setDrawerStatus(status){
      let $this = this;
      if(status){
        $this.classList.remove('wishlist-empty');
      }else{
        setTimeout(()=>{
          $this.classList.add('wishlist-empty');
        },500)
      }
    }
    removeProductFromSessionStorage(productIdToRemove) {
      let storedData = localStorage.getItem('wishlist_items');
      if (storedData) {
        let jsonData = JSON.parse(storedData);
        let updatedData = jsonData.filter(product => product.id !== productIdToRemove);
        localStorage.setItem('wishlist_items', JSON.stringify(updatedData));
        this.updateWishlistBubble();
      }
      // this.renderContentFromSessionStorage();
    }

  }
  customElements.define('wishlist-drawer', WishlistDrawer);



  class WishlistItems extends HTMLElement{
    constructor() {
      super();

    }
  }
  customElements.define('wishlist-items', WishlistItems);



  class WishlistItem extends WishlistItems {
  }
  customElements.define('wishlist-item', WishlistItem);



  class WishlistDeleteButton extends WishlistItem {
    constructor() {
      super();
      this.addEventListener('click', this.removeItem);
    }

    removeItem(){
      let product_id = this.dataset.id;
      this.sendDeleteRequest(product_id);
      document.querySelector('wishlist-drawer').removeProductFromSessionStorage(product_id);
      this.fadeAndRemove(this.closest('wishlist-item'));

      const wishlistButtons = document.querySelectorAll('wishlist-button');
      wishlistButtons.forEach(button => {
        button.classList.toggle('has_in_wishlist', this.checkIfProductExistInWishlist(button.dataset.id));
      });
    }
    checkIfProductExistInWishlist(productId){
      const storedData = localStorage.getItem('wishlist_items');
      if (storedData) {
        const productData = JSON.parse(storedData);
        // Check if any product has the provided productId
        const exists = productData.some(product => product.id === productId);
        return exists;
      } else {
        return false; // Assuming product doesn't exist if no data is available
      }
    }
    fadeAndRemove(el) {
      var opacity = 1;
      var interval = setInterval(function() {
      if (opacity > 0) {
        opacity -= 0.1;
        el.style.opacity = opacity;
      } else {
        clearInterval(interval);
        el.style.display = 'none';
        el.remove()
      }
      }, 25);
    }

    sendDeleteRequest(itemId) {
      // Define the endpoint with the {id} parameter
      const endpoint = `${wishlist_api}/api/wishlist`;
    
      // Define the payload with the user_id
      const payload = {
            user_id: localStorage.getItem('userId'),
            product_id: itemId
        };
    
      // Convert the payload to JSON
      const payloadJSON = JSON.stringify(payload);
    
      // Define the options for the fetch request
      const requestOptions = {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
        body: payloadJSON,
      };
    
      // Send the DELETE request
      fetch(endpoint, requestOptions)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
        })
        .catch(error => {
          // Handle errors here
          console.error('Error:', error);
        });
    }


  }
  customElements.define('wishlist-item-delete-button', WishlistDeleteButton);


  class WishlistButton extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('click', this.handleButtonClicked);
      if(this.checkIfProductExistInWishlist(this.dataset.id)){
        this.classList.add('has_in_wishlist');
      }
    }

    handleButtonClicked(){
      let prod = this.getProductObject(this.dataset);
      if(this.classList.contains('has_in_wishlist')){
          this.classList.remove('has_in_wishlist');
          this.removeFromWishlist(prod);
      }else{
        this.classList.add('has_in_wishlist');
        this.addToWishlist(prod);
        setTimeout(()=>{
          // location.reload();
          this.openDrawer();
        },200);
      }
      document.querySelector('wishlist-drawer').renderContentFromSessionStorage()
    }

    addToWishlist(prod){
      this.appendJsonToLocalStorage(prod);
      this.sendWishlistItem(prod);
    }

    removeFromWishlist(prod){
      document.querySelector('wishlist-drawer').removeProductFromSessionStorage(prod.id);
      document.querySelector('wishlist-item-delete-button').sendDeleteRequest(prod.id);
    }

    openDrawer(){
      document.querySelector('wishlist-drawer').open()
    }

    getProductObject(prod){
      console.log("prod",prod)
      return {
        'has_only_default_variant': prod.has_only_default_variant,
        'id': prod.id,
        'title':  prod.title,
        'price_varies': prod.price_varies,
        'price': prod.price,
        'price_max': prod.price_max,
        'price_min': prod.price_min,
        'src': prod.src,
        'url': prod.url,
        'variantId': prod.variantId,
        'is_available':prod.proavil,
        'tags':prod.tags,
        'promo_images':prod.promoimage,
        'product_pergram':prod.product_gram

      }
    }

    appendJsonToLocalStorage(jsonData) {
      let existingData = localStorage.getItem('wishlist_items');
      let parsedData = existingData ? JSON.parse(existingData) : [];
      
      // prevent duplicates
      if (!parsedData.some(p => p.id === jsonData.id)) {
        parsedData.push(jsonData);
        localStorage.setItem('wishlist_items', JSON.stringify(parsedData));
      }
    }



    checkIfProductExistInWishlist(productId){
      const storedData = localStorage.getItem('wishlist_items');
      if (storedData) {
        const productData = JSON.parse(storedData);
        // Check if any product has the provided productId
        const exists = productData.some(product => product.id === productId);
        return exists;
      } else {
        return false; // Assuming product doesn't exist if no data is available
      }
    }

    sendWishlistItem(prod) {
      // Get the user_id from local storage
      const userId = localStorage.getItem('userId');
      const endpoint = `${wishlist_api}/api/wishlist`;

      // Define the dynamic payload
      const dynamicPayload = {
        user_id: userId,
        ...prod
      };
      // Convert the dynamic payload to JSON
      const dynamicPayloadJSON = JSON.stringify(dynamicPayload);
    
      // Define the options for the fetch request
      const requestOptions = {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: dynamicPayloadJSON,
      };
    
      // Send the POST request
      fetch(endpoint, requestOptions)
        .then(response => {
          if (!response.ok) {
            throw new Error('Network response was not ok');
          }
          return response.json(); // If you expect a JSON response
        })
        .then(data => {
        })
        .catch(error => {
          // Handle errors here
          console.error('Error:', error);
        });
    }


  }
  customElements.define('wishlist-button', WishlistButton);


  class WishlistATCButton extends HTMLElement{
    constructor() {
      super();
      this.addEventListener('click', this.quickAddToCart);
    }
    quickAddToCart() {
      var $this = this;
      if(this.getAttribute("disabled")){
        alert('Clicked')
      }else{
        this.setAttribute("disabled", true);
        this.innerHTML = `<svg aria-hidden="true" focusable="false" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
        </svg>  הוספה לעגלה`;
        let product_id = this.dataset.id;
        var xhr = new XMLHttpRequest();
        xhr.open("POST", "/cart/add.js", true);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.onreadystatechange = function () {
          if (xhr.readyState === 4) {
            if (xhr.status === 200) {
              var data = JSON.parse(xhr.responseText);
              // Success handling
              fetch(`${routes.cart_url}?sections=cart-drawer,cart-icon-bubble`)
              .then((response) => response.json())
              .then((response) => {
                  let responseFormated = {
                      sections: response,
                      ...data.items[0]
                  }
                  let cart_drawer = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
                  cart_drawer.renderContents(responseFormated);
                  $this.innerHTML = `הוספה לסל הקניות`;
                  if (cart_drawer && cart_drawer.classList.contains('is-empty')) cart_drawer.classList.remove('is-empty');
                  $this.removeAttribute("disabled");

                  document.querySelector('wishlist-item-delete-button').sendDeleteRequest(product_id);
                  document.querySelector('wishlist-drawer').removeProductFromSessionStorage(product_id);
                  document.querySelector('wishlist-drawer').renderContentFromSessionStorage();
              })
            } else {
              // Failure handling
              $this.innerHTML = `הוספה לסל הקניות`;
              $this.removeAttribute("disabled");
            }
          }
        };
        var data = JSON.stringify({
          items: [{
            id: this.dataset.variantId,
            quantity: 1
          }]
        });
        xhr.send(data);
      }
    }

    fadeAndRemove(el) {
      var opacity = 1;
      var interval = setInterval(function() {
      if (opacity > 0) {
        opacity -= 0.1;
        el.style.opacity = opacity;
      } else {
        clearInterval(interval);
        el.style.display = 'none';
        el.remove()
      }
      }, 25);
    }
  }
  customElements.define('add-to-cart', WishlistATCButton);

